var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_line",
    clipPath: "url(#clip0_373_32947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99956 8.94342L11.7709 12.7148C11.8966 12.8362 12.065 12.9034 12.2398 12.9019C12.4146 12.9003 12.5818 12.8302 12.7054 12.7066C12.829 12.583 12.8992 12.4158 12.9007 12.241C12.9022 12.0662 12.835 11.8978 12.7136 11.7721L8.94222 8.00075L12.7136 4.22942C12.835 4.10368 12.9022 3.93528 12.9007 3.76048C12.8992 3.58569 12.829 3.41848 12.7054 3.29487C12.5818 3.17127 12.4146 3.10115 12.2398 3.09963C12.065 3.09812 11.8966 3.16531 11.7709 3.28675L7.99956 7.05808L4.22822 3.28675C4.10192 3.16831 3.9345 3.10366 3.76138 3.10647C3.58825 3.10928 3.42302 3.17934 3.30063 3.30181C3.17824 3.42429 3.1083 3.58957 3.10561 3.7627C3.10293 3.93582 3.1677 4.1032 3.28622 4.22942L7.05689 8.00075L3.28556 11.7721C3.22188 11.8336 3.1711 11.9071 3.13616 11.9885C3.10122 12.0698 3.08283 12.1573 3.08206 12.2458C3.08129 12.3343 3.09815 12.4221 3.13168 12.5041C3.1652 12.586 3.2147 12.6604 3.27729 12.723C3.33989 12.7856 3.41432 12.8351 3.49625 12.8686C3.57818 12.9022 3.66597 12.919 3.75449 12.9183C3.84301 12.9175 3.93049 12.8991 4.01183 12.8642C4.09316 12.8292 4.16673 12.7784 4.22822 12.7148L7.99956 8.94342Z",
    fill: "#727272"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_32947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLine);
export default __webpack_public_path__ + "static/media/close_line.19aa1a2f82a77b55070715ddda7a8de4.svg";
export { ForwardRef as ReactComponent };